import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import { Alert, Box, Button, Fade, Modal } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useDispatch, useSelector } from "react-redux";
import { StyledModalRoot } from "../styled/modal";
import { generateLinks, sendWhatsAppLinkMessage } from "../../utils/messages";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import { ButtonInfoNoShadow } from "../styled/button";
import { setShowShippingRouteModal } from "../../store/actions/shippingRoutesSlice";
import { dispatchSnackBarMessage } from "../../utils/snackbar";
import { setShowOrderInfosModal } from "../../store/actions/ordersSlice";
import { printShippingRoute } from "../../utils/printService";
import ShippingRouteDetailsTicket from "./ShippingRouteDetailsTicket";

const ShippingRouteModal = ({ show, closeModal }) => {
  const componentRef = useRef();

  const dispatch = useDispatch();

  const [ticketHeightInMM, setTicketHeightInMM] = useState(0);
  const [ticketWidthInMM, setTicketWidthInMM] = useState(0);

  const [printed, setPrinted] = useState(false);

  const shippingRoute = useSelector(
    (state) => state.shippingRoutes.shippingRoute
  );

  const showOrderInfosModal = useSelector(
    (state) => state.orders.showOrderInfosModal
  );

  // Use the hook at the top level
  const reactToPrintTrigger = useReactToPrint({
    contentRef: componentRef,
    onPrintError: (errorLocation, error) => {
      console.error(`Print error at ${errorLocation}:`, error);
      dispatchSnackBarMessage(
        `print-error-${Date.now()}`,
        `Erro ao imprimir: ${error.message}`,
        "error"
      );
    },
    pageStyle: `
      @media print {
        @page {
          margin: 0;
          size: auto ${ticketHeightInMM}mm;
        }
        @top-left { content: none; }
        @top-center { content: none; }
        @top-right { content: none; }
        @bottom-left { content: none; }
        @bottom-center { content: none; }
        @bottom-right { content: none; }
      }
    `,
    onAfterPrint: () => setPrinted(true),
  });

  useEffect(() => {
    if (componentRef.current) {
      const boundingRect = componentRef.current.getBoundingClientRect();

      // Calculating height
      const height = boundingRect.height;
      const pixelsPerMM = 96 / 25.4; // Standard pixel density
      const heightInMM = height / pixelsPerMM;
      setTicketHeightInMM(heightInMM);

      // Calculating width
      const width = boundingRect.width;
      const widthInMM = width / pixelsPerMM;
      setTicketWidthInMM(widthInMM);
    }
  }, [componentRef]);

  const handleCloseModal = (e) => {
    dispatch(setShowShippingRouteModal({ show: false, shippingRoute: null }));
  };

  const handleWhatsAppMessage = () => {
    const coordinates = shippingRoute.shipping_routes_orders.map((order) => {
      return { lat: order.fk_order.lat, lng: order.fk_order.lng };
    });

    const { googleMapsLink, wazeLink } = generateLinks(coordinates);

    sendWhatsAppLinkMessage(
      shippingRoute.driver.phone,
      googleMapsLink,
      wazeLink
    );
  };

  const handlePrint = async () => {
    try {
      console.log("shippingRoute", shippingRoute);
      await printShippingRoute({ route: shippingRoute });
      setPrinted(true);
    } catch (e) {
      // Fallback to react-to-print
      reactToPrintTrigger();
    }
  };

  const handleOrderInfoModal = (order_id) => {
    dispatch(
      setShowOrderInfosModal({
        orderId: order_id,
        show: !showOrderInfosModal,
      })
    );
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={handleCloseModal}
      closeAfterTransition
      sx={{ zIndex: 9999 }}
    >
      <Fade in={show} mountOnEnter unmountOnExit>
        <StyledModalRoot overflow={"auto"}>
          <Box sx={{ width: "100%", maxWidth: 600, margin: "0 auto" }}>
            <Alert severity="success" sx={{ mb: 2 }}>
              Pedidos despachados com sucesso!
            </Alert>

            <div style={{ display: "none" }}>
              <ShippingRouteDetailsTicket
                shippingRoute={shippingRoute}
                componentRef={componentRef}
                onOrderClick={handleOrderInfoModal}
                forPrinting={true}
              />
            </div>

            <ShippingRouteDetailsTicket
              shippingRoute={shippingRoute}
              componentRef={componentRef}
              onOrderClick={handleOrderInfoModal}
            />

            <Box
              sx={{
                p: 2,
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                variant="text"
                startIcon={<WhatsAppIcon />}
                onClick={handleWhatsAppMessage}
              >
                Enviar Link Entregador
              </Button>
              <IconButton onClick={handlePrint} color="primary">
                <PrintIcon />
              </IconButton>
            </Box>
            {printed && (
              <Box sx={{ p: 1, mb: 1 }}>
                <ButtonInfoNoShadow fullWidth onClick={handleCloseModal}>
                  Fechar
                </ButtonInfoNoShadow>
              </Box>
            )}
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
};

export default ShippingRouteModal;
